<script>
    import {USER_ROLES} from "../../lib/constants";
    import R, {LOADER} from "../../lib/requests";
    import {clickOutside} from '../../lib/clickOutside.js';
    import {createEventDispatcher} from 'svelte/internal';

    export let excludeFromSelection = []; // objects to exclude from selection
    export let placeholder = '';

    let name = '';
    let results = [];
    let listIndex = -1;
    let excludeIds = [];
    let timer;
    let showDropdown = false;

    const dispatch = createEventDispatcher();

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            closeDropdown();
        }
    }

    const onNameKeydown = (event) => {
        if (results && results.length) {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                listIndex++;
                if (listIndex >= results.length) {
                    listIndex = 0;
                }
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                listIndex--;
                if (listIndex < 0) {
                    listIndex = results.length - 1;
                }
            } else if (event.key === 'Enter' && listIndex > -1) {
                event.preventDefault();
                selectResult(results[listIndex]);
            } else if (event.key === 'Escape') {
                closeDropdown();
            }
        }
    }

    const onNameKeyup = (event) => {
        if (name !== event.target.value) {
            name = event.target.value;
            if (timer) {
                clearInterval(timer);
            }
            if (name.length) {
                timer = setInterval(() => {
                    clearInterval(timer);
                    search();
                }, 500);
            } else {
                closeDropdown();
            }
        }
    }

    const selectResult = (item) => {
        name = item.name;
        dispatch('select', item);
        closeDropdown();
    }

    const search = () => {
        const onSuccess = result => {
            results = [];
            result.map(item => {
                if (excludeIds.indexOf(item.id) < 0) {
                    results.push(item);
                }
            });
            openDropdown();
        }

        const onFailure = err => {
        };

        R.handle(R.user.index, {name}, onSuccess, onFailure);
    }

    const openDropdown = () => {
        if (!showDropdown) {
            showDropdown = true;
            document.addEventListener('keydown', handleEscapeKey);
        }
    }

    const closeDropdown = () => {
        if (showDropdown) {
            showDropdown = false;
            results = [];
            listIndex = -1;
            name = '';
            document.removeEventListener('keydown', handleEscapeKey);
        }
    }


    $: {
        if (excludeFromSelection) {
            if (excludeFromSelection.length != excludeIds.length) {
                excludeIds = excludeFromSelection.map(item => {
                    return item.id;
                });
            }
        } else {
            excludeIds = [];
        }
    }
</script>

<div class="dropdown-container" use:clickOutside on:click_outside="{ closeDropdown }">
    <div>
        <input type="text" class="form-control" id="searchClientName" value="{ name }"
               on:keydown="{ onNameKeydown }"
               on:keyup="{ onNameKeyup }"
               {placeholder}
               autocomplete="off">
    </div>
    {#if showDropdown}
        <ul class="dropdown">
            {#if results.length}
                {#each results as item, index}
                    <li class="dropdown-item pointer" class:selected="{ listIndex === index }"
                        on:click="{ () => selectResult(item) }">
                        <div class="smaller">{ USER_ROLES[item.role] }</div>
                        { item.name }
                    </li>
                {/each}
            {:else}
                <li class="p-2">
                    no users found!
                </li>
            {/if}
        </ul>
    {/if}
</div>